import { render, staticRenderFns } from "./ErrorCom.vue?vue&type=template&id=4d0ea9b5&"
import script from "./ErrorCom.vue?vue&type=script&lang=js&"
export * from "./ErrorCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports